import React from "react";
import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";

const WhatsAppFlotante = () => {
  const { openConsultaForm, loading } = useWhatsAppConsulta();

  return (
    <div className="whatsapp-container">
      <button className="btn-whatsapp-flotante" onClick={openConsultaForm} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;
